import { THEMES, Theme } from '@cmctechnology/webinvest-constants';

// Mapping of theme names as they are imported from EORA Figma
export const eoraThemeName: Record<Theme, string> = {
  [THEMES.Advantage]: 'ADVANTAGE',
  [THEMES.Bendigo]: 'BENDIGO',
  [THEMES.CMC]: 'CMC',
  [THEMES.CMCAlpha]: 'ALPHA',
  [THEMES.CMCSingapore]: 'CMC',
  [THEMES.eBroking]: 'E_BROKING',
  [THEMES.Rivkin]: 'RIVKIN',
  [THEMES.StGeorge]: 'ST_GEORGE',
  [THEMES.ASB]: 'ASB',
  [THEMES.Westpac]: 'WESTPAC'
};
